import {Box, styled} from '@mui/material';

const Container = styled(Box)`
	padding: 16px;
	height: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px 32px;
	}
`;

const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 60px;
	}
`;

export {Container, StyledBox};
